import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Spinner from '../Spinner/Spinner.js';
import PageHeading from '../PageHeading/PageHeading.js';
import ImageGrid from '../ImageGrid/ImageGrid.js';


class AffiliationsBlock extends Component {
    constructor(props) {
        super(props);
        /**  The data for the image grid is controlled by the imageGridData state. 
         * itemAttributes defines structural levels: ItemAttributes(Array) -> row -> grid item -> attribute. 
         * Note* 'gridTweak' is to override the itemGridClass for a specific item.
        */
        this.state = {
            imageGridData: {
                data: {
                    itemClass: 'affiliations-block__item',
                    itemGridClass: 'col-xs-6 col-sm-6 col-md-3 col-lg-3',
                    itemImgClass: 'affiliations-block__img',
                    itemAttributes: [
                        [
                            { itemTargetingClass: 'cfre', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-cfre-2024.png', imageAlt: 'CFRE Logo', gridTweak: '' },
                            { itemTargetingClass: 'hrci', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-hrci-2024.png', imageAlt: 'HRCI Institute Logo', gridTweak: '' },
                            { itemTargetingClass: 'auth-provider', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-authorized-provider.png', imageAlt: 'Authorized Provider Logo', gridTweak: '' },
                            { itemTargetingClass: 'pmi', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-pmi-2024.png', imageAlt: 'Project Management Institute Logo', gridTweak: '' },
                        ],
                        [
                            { itemTargetingClass: 'shrm', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-shrm-2022.png', imageAlt: 'SHRM Logo', gridTweak: '' },
                            { itemTargetingClass: 'comptia', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-comptia-trans.png', imageAlt: 'CompTIA Logo', gridTweak: '' },
                            { itemTargetingClass: 'ace', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-ace-2020.png', imageAlt: 'Ace Logo', gridTweak: '' },
                            { itemTargetingClass: 'atdci', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-atdci.png', imageAlt: 'ATD CI Credits Logo', gridTweak: '' },
                        ],
                        [
                            { itemTargetingClass: 'omcp', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-omcp.png', imageAlt: 'OMCP Logo', gridTweak: '' },
                            { itemTargetingClass: 'ama', imageSrc: 'https://cdn.skyelearning.com/static/partner-logos/partner-ama-pcm-2023.png', imageAlt: 'AMA Logo', gridTweak: '' }

                        ]
                    ]

                },
            },
            blockTitle: '',
            isLoading: true
        };
    }

    componentDidMount() {
        this.setState({ blockTitle: this.props.blockTitle });
        this.setState({ isLoading: false });
    }

    render() {
        const blockTitle = ReactHtmlParser(this.state.blockTitle);
        const blockTextContent = this.props.blockTextContent ? ReactHtmlParser(this.props.blockTextContent) : '';
        const additionalContent = this.props.additionalContent ? ReactHtmlParser(this.props.additionalContent) : '';
        return (
            <div id="affiliationsBlockComponent">
                <Spinner isLoading={this.state.isLoading}></Spinner>
                <div className="container affiliations-block__container">
                    <PageHeading
                        titleClass={this.props.blockTitleClass}
                        titleText={blockTitle}
                        level={this.props.blockTitlelevel}
                    />
                    { blockTextContent ? <p className={this.props.textContentClassName + ' ubuntu'} tabIndex="0">{blockTextContent}</p>
                     : ''}
                    <ImageGrid
                        data={this.state.imageGridData.data}
                    />
                     { additionalContent ? <p tabIndex="0" className={additionalContent + ' mt-4'}>{additionalContent}</p> : '' }
                </div>
            </div>
        );
    }
}

export default AffiliationsBlock;